import User from '@/domain/user/user.entity';

export class ProjectMember {
  user: User;

  roleId?: string;

  roleName?: string;

  seniorityId?: string;

  seniorityName?: string;

  constructor(obj: any) {
    this.user = obj.user;
    this.roleId = obj.roleId;
    this.roleName = obj.roleName;
    this.seniorityId = obj.seniorityId;
    this.seniorityName = obj.seniorityName;
  }
}

export default class ProjectWithMembers {
  id: string;

  name: string;

  description?: string;

  members: ProjectMember[];

  businessUnitId: string;

  costCenterId: string;

  manager: User;

  allowMandalaEditClosedVsts: boolean = false;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.members = (obj.members || []).map((member: any) => new ProjectMember(member));
    this.businessUnitId = obj.businessUnitId || '';
    this.costCenterId = obj.costCenterId || '';
    this.manager = obj.manager || {};
    this.allowMandalaEditClosedVsts = obj.allowMandalaEditClosedVsts || false;
  }

  public static of(value: any): ProjectWithMembers {
    return new ProjectWithMembers(value || {});
  }

  public static ofList(response: any): ProjectWithMembers[] {
    return response.data.map(this.of);
  }
}
